module.exports = "/assets/fa9805176c1389e3c2dcbb0faae54d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/6Q.png
// module id = 1094
// module chunks = 0